import screen from './Main';

export default screen;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/Detail/index.js